export const WORKKARD_FIELD_KEY = Object.freeze({
  NUMBER: "workkardnumber",
  TITLE: "workkardtitle",
  OWNER: "workkardowner",
  CARRIER: "carrier",
  DESCRIPTION: "workkarddescription_richtext_static",
});

export const WORKKARD_FIELD_LABEL = Object.freeze({
  NUMBER: "Workkard Number",
  TITLE: "Workkard Title",
  OWNER: "Workkard Owner",
  CARRIER: "Carrier",
  DESCRIPTION: "Workkard Description",
});

export const MAILING_SAME_AS_ABOVE_FIELD_KEY =
  "mailingsameasabove_checkbox_static";

export const PROPERTY_LOCATION_PREFIX = "propertylocation_";
export const MAILING_ADDRESS_PREFIX = "mailingaddress_";

export const MAILING_ADDRESS_GROUP_LABEL = "Mailing Address";

export const OWNER_PLACEHOLDER = "Select Owner";
export const CARRIER_PLACEHOLDER = "Select Carrier";

export const NON_TEMPLATE_FIELD_KEYS = Object.freeze(new Set([
  WORKKARD_FIELD_KEY.NUMBER,
  WORKKARD_FIELD_KEY.TITLE,
  WORKKARD_FIELD_KEY.OWNER,
  WORKKARD_FIELD_KEY.CARRIER,
  WORKKARD_FIELD_KEY.DESCRIPTION,
  'templateShortName',
  MAILING_SAME_AS_ABOVE_FIELD_KEY
]))